import { render, staticRenderFns } from "./MTDform.vue?vue&type=template&id=15482264&scoped=true&"
import script from "./MTDform.vue?vue&type=script&lang=js&"
export * from "./MTDform.vue?vue&type=script&lang=js&"
import style0 from "./MTDform.vue?vue&type=style&index=0&id=15482264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15482264",
  null
  
)

export default component.exports